import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { VaultProvider } from './context/VaultContext.jsx';
import BasicAuth from './components/BasicAuth.jsx';
import MobileNavbar from './components/MobileNavbar.jsx';
import { isSessionValid } from './utils/auth.js';
import HomePage from './pages/HomePage.jsx';
import CategoryPage from './pages/CategoryPage.jsx';
import NamingFamily from './pages/NamingFamily.jsx';
import AuthenticatorPage from './pages/AuthenticatorPage.jsx';
import FamilyGallery from './pages/FamilyGallery.jsx';
import VaultPage from './pages/VaultPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';
import EchoChamberPage from './pages/EchoChamberPage.jsx';
import EchoChamberInfo from './pages/EchoChamberInfo.jsx';
import ActivityDashboardPage from './pages/ActivityDashboardPage.jsx';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check if user has valid session
    const hasValidSession = isSessionValid();
    setIsAuthenticated(hasValidSession);
    setIsChecking(false);
  }, []);

  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        background: '#000',
        color: '#d4af37' 
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-4 9 4v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke="#d4af37" strokeWidth="1.5" fill="rgba(212,175,55,0.2)"/>
              <path d="M9 22V12h6v10M12 2L3 9M12 2l9 7" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            JK Legacy
          </h2>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <VaultProvider>
        <Router>
          <BasicAuth onAuthenticated={() => setIsAuthenticated(true)}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/category/:category" element={<CategoryPage />} />
              <Route path="/profile/:profileId" element={<ProfilePage />} />
              <Route path="/naming" element={<NamingFamily />} />
              <Route path="/authenticator" element={<AuthenticatorPage />} />
              <Route path="/gallery" element={<FamilyGallery />} />
              <Route path="/vault" element={<VaultPage />} />
              <Route path="/activity-dashboard" element={<ActivityDashboardPage />} />
              <Route path="/echo-chamber" element={<EchoChamberPage />} />
              <Route path="/echo-chamber/info" element={<EchoChamberInfo />} />
            </Routes>
            <MobileNavbar />
          </BasicAuth>
        </Router>
      </VaultProvider>
    </ErrorBoundary>
  );
}
